import {Component, OnInit, ViewChild} from '@angular/core';
import {TdoTableBaseItemModel} from '../../../tdo-controls/common/tdo-table/models/tdo-table-base-item.model';
import {ITdoTableItemModel} from '../../../tdo-controls/common/tdo-table/interfaces/i-tdo-table-item.model';
import {TdoTableActionsEnum, TdoTableModel} from '../../../tdo-controls/common/tdo-table/models/tdo-table.model';
import {TdoTableComponent} from '../../../tdo-controls/common/tdo-table/tdo-table.component';
import {CfgARAccountModel} from '../../../models/accountsReceivable/cfg-ar-account.model';
import {DataSource} from '@angular/cdk/collections';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Globals} from '../../../globals';
import {DialogService} from '../../../services/dialog.service';
import {MatDialog} from '@angular/material/dialog';
import {ARAccountConfigurationService} from './ar-account-configuration-service';
import {MatTableDataSource} from '@angular/material/table';
import {TdoTableEvent} from '../../../tdo-controls/common/tdo-table/models/tdo-table.event';
import {ConfigurationService} from '../configuration.service';

export class TableViewData extends TdoTableBaseItemModel implements ITdoTableItemModel {
  AccountName: string;
  AccountNumber: string;
  actions = [TdoTableActionsEnum.DELETE];
  model: CfgARAccountModel;

  getActionTooltip(actionName: string): string {
    return `Delete ${this.AccountName}`;
  }
}

@Component({
  selector: 'app-ar-account-configuration',
  templateUrl: './ar-account-configuration.component.html',
  styleUrls: ['./ar-account-configuration.component.scss']
})
export class ArAccountConfigurationComponent implements OnInit {

  @ViewChild('accountsTable') accountsTable: TdoTableComponent;

  accountList: CfgARAccountModel[] = [];
  selectedAccount: CfgARAccountModel;
  selectedAccountRevert: CfgARAccountModel;

  // table
  tableModel: TdoTableModel;
  tableViewData: TableViewData[];
  displayedColumns: string[] = ['AccountName', 'AccountNumber'];
  displayedColumnsLabels: string[] = ['Name', 'Number'];
  dataSource: DataSource<TableViewData>;

  isSaved: boolean = false;
  saveDisabled: boolean = true;
  isEditing: boolean = false;
  isLoading: boolean = false;

  constructor(
    private snackBar: MatSnackBar,
    private globals: Globals,
    private dialogService: DialogService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    public configurationService: ConfigurationService,
    private accountService: ARAccountConfigurationService,
  ) { }

  ngOnInit(): void {
    // get accounts
    this.accountService.getAccounts().subscribe((list) => {
      this.accountList = list;

      if (list.length > 0) {
        // accounts exist
        this.selectedAccount = this.accountList[0];
        this.setSelectedAccountRevert(this.selectedAccount);
        this.refreshTableViewData(this.accountList);
      }
      else {
        // no accounts exist
        this.refreshTableViewData(this.accountList);
        this.isLoading = false;
      }
    }, err => {
      this.createMessage('Error loading task types', 'Error');
    });

  }

  // Data change
  refreshTableViewData(models: CfgARAccountModel[]): void {
    this.accountList = models;
    this.tableViewData = Array.from(this.accountList, (_) => {
      const model = new TableViewData();
      model.AccountName = _.AccountName;
      model.AccountNumber = _.AccountNumber;
      model.model = _;
      return model;
    });
    if (!this.tableModel) {
      this.dataSource = new MatTableDataSource(this.tableViewData);
      this.tableModel = new TdoTableModel(this.displayedColumns, this.displayedColumnsLabels, this.dataSource, 'OperatoryName', 'asc');
      this.tableModel.searchPredicate = (data: TableViewData, filter: string) => {
        if (data.AccountName.toLowerCase().includes(filter)) {
          return true;
        }
      };
    } else {
      (this.dataSource as MatTableDataSource<TableViewData>).data = this.tableViewData;
      (this.dataSource as MatTableDataSource<TableViewData>)._updateChangeSubscription();
    }
  }

  setSelectedAccountRevert(account: CfgARAccountModel) {
    this.selectedAccountRevert = new CfgARAccountModel();
    this.selectedAccountRevert.AccountName = account.AccountName;
    this.selectedAccountRevert.AccountNumber = account.AccountNumber;
  }

  revertSelectedAccount() {
    this.accountList.forEach(a => {
      if (this.selectedAccount.ARAccountID === a.ARAccountID) {
        a.AccountName = this.selectedAccountRevert.AccountName;
        a.AccountNumber = this.selectedAccountRevert.AccountNumber;
      }
    });
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  onTdoTableItemActionClick(event: TdoTableEvent): void {
    switch (event.action) {
      case TdoTableActionsEnum.DELETE:
        const model = (event.value as TableViewData).model;
        this.dialogService.openConfirmDialog(`Are you sure you want to delete ${model.AccountName}?`).subscribe((result) => {
          if (result === true) {
            this.accountList = this.accountList.filter(a => a !== model);
            this.selectedAccount = this.accountList[0];
            this.refreshTableViewData(this.accountList);
            if (this.accountList.length > 0) { this.accountsTable.selectRow(this.accountList[0]); }

            // save removal
            this.accountService.removeAccount(model).subscribe((remove) => {
              if (remove) {
                this.createMessage('Account removed', 'Success');
              }
            });
          }
        });
        break;
    }
  }

  onTdoTableItemClick(event: TdoTableEvent): void {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.revertSelectedAccount();

          this.selectedAccount = (event.value as TableViewData).model;
          this.setSelectedAccountRevert(this.selectedAccount);
          this.isEditing = false;
          this.saveDisabled = true;
          return;
        } else {
          // Set selection back to prior because it was cancelled // TDO switch to new tdo table
        }
      });
    } else {
      this.revertSelectedAccount();

      this.selectedAccount = (event.value as TableViewData).model;
      this.setSelectedAccountRevert(this.selectedAccount);
      this.isEditing = false;
      this.saveDisabled = true;
    }
  }

  onEdit(event) {
    this.saveDisabled = false;
    this.isEditing = true;
  }

  onSave(event) {
    this.configurationService.setClean();
    // reset saved vars
    this.isSaved = false;
    this.isLoading = true;

    // save changes to db
    this.accountService.saveAccount(this.selectedAccount).subscribe(saved => {
      if (saved)
      {
        // save successful
        this.createMessage('Account saved', 'Success');
        this.isSaved = true;
        this.selectedAccount = saved;
        this.setSelectedAccountRevert(this.selectedAccount);

        // reload list
        this.accountService.getAccounts().subscribe(accounts => {

          this.accountList = accounts;
          this.refreshTableViewData(this.accountList);

          const selectRow = this.accountList.find(a => a.ARAccountID === saved.ARAccountID);
          if (selectRow) {
            this.accountsTable.selectRow(selectRow);
            this.selectedAccount = selectRow;
          }
        }, err => {
        });

        this.isLoading = false;
      }
    }, err => {
      this.createMessage('Error saving task', 'Error');
      this.isLoading = false;
    });
  }

  onCancel(event) {
    this.configurationService.setClean();
    this.saveDisabled = true;
    this.isEditing = false;

    // revert changes
    this.revertSelectedAccount();
  }

  onNew(event) {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.addAccount();
        } else {
          // Set selection back to prior because it was cancelled // TDO switch to new tdo table
        }
      });
    } else {
      this.addAccount();
    }
  }

  addAccount() {
    // revert changes
    this.revertSelectedAccount();

    const newAccount = new CfgARAccountModel();
    this.selectedAccount = newAccount;
    this.accountList.push(newAccount);
    this.refreshTableViewData(this.accountList);

    this.createMessage('Account added', 'Success');
    this.isSaved = true;

    // simulate edit
    this.saveDisabled = false;
    this.isEditing = true;
    this.setSelectedAccountRevert(this.selectedAccount);
  }
}
